import axios from "axios";

const APIpath = "https://gulaker-mat.herokuapp.com/";
//"http://127.0.0.1:8000/";

export default {
  methods: {
    API_headers(contains_JSON) {
      var headers = {};
      if (this.$session.has("token"))
        headers["Authorization"] = `Token ${this.$session.get("token")}`;
      if (contains_JSON) headers["Content-Type"] = "application/json";
      return headers;
    },
    APIget(path) {
      var output = { status: null, data: null, error: null };
      return axios
        .get(APIpath + path, {
          headers: this.API_headers()
        })
        .then(
          response => {
            output.status = response.status;
            output.data = response.data;
            return output;
          },
          error_ => {
            output.error = error_;
            if (error_.response) {
              output.status = error_.response.status;
              output.data = error_.response.data;
            }
            return output;
          }
        );
    },
    APIpost(path, data) {
      var output = { status: null, data: null, error: null };
      return axios
        .post(APIpath + path, data, {
          headers: this.API_headers()
        })
        .then(
          response => {
            output.status = response.status;
            output.data = response.data;
            return output;
          },
          error_ => {
            output.error = error_;
            if (error_.response) {
              output.status = error_.response.status;
              output.data = error_.response.data;
            }
            return output;
          }
        );
    },
    APIput(path, data) {
      var output = { status: null, data: null, error: null };
      return axios
        .put(APIpath + path, data, {
          headers: this.API_headers()
        })
        .then(
          response => {
            output.status = response.status;
            output.data = response.data;
            return output;
          },
          error_ => {
            output.error = error_;
            if (error_.response) {
              output.status = error_.response.status;
              output.data = error_.response.data;
            }
            return output;
          }
        );
    }
  }
};
